import { render, staticRenderFns } from "./MyDormRoomType.vue?vue&type=template&id=65577756&scoped=true&"
import script from "./MyDormRoomType.vue?vue&type=script&lang=js&"
export * from "./MyDormRoomType.vue?vue&type=script&lang=js&"
import style0 from "./MyDormRoomType.vue?vue&type=style&index=0&id=65577756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65577756",
  null
  
)

component.options.__file = "MyDormRoomType.vue"
export default component.exports